
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import AuditTable from "@/views/components/AuditTable.vue";
import { deepClone } from "@/utils/deepClone";
import Template from "@/views/system-management/template/index.vue";
import {FinancialConfiguration} from "@/model/FinancialBookingModels";

@Component({
  name: "Item",
  components: {
    Template,
    AuditTable
  }
})

export default class extends Vue {
  @Prop({ default: {} }) private source: any;
  @Prop({ default: {} }) private loadingAudit: {};
  @Prop({ default: 0 }) private index: number;
  @Prop({ default: false }) private canEditAudit: boolean;
  @Prop({ default: '' }) private financialConfiguration: '';
  @Prop({ default: Function }) private showExtraDialog: Function;
  @Prop({ default: Function }) private calculateTotal: Function;
  @Prop({ default: Function }) private updateData: Function;
  @Prop({ default: Function }) private updatePaymentOrderFa: Function;
  // @Prop({ default: "分批结算" }) private title: "";

  public extraDialog(val,index) {
    this.showExtraDialog(val,index,(this.$refs.auditTableTable as any))
  }
  public calculateTotalItem(name) {
    this.calculateTotal(name)
  }
  public updateData_(data) {
    this.updateData(data,this.index);
  }
  public updateDeductionAndFilling(data) {
    this.updateData(data,this.index);
    this.calculateTotal('totalSettlementAmount');
    // this.calculateTotal('totalDeclarationAmount');
  }
  public updatePaymentOrderSon(item) {
    this.updatePaymentOrderFa(item.factoryName)
  }
  public calculateFcr(data) {
    this.source.totalSettlementAmount = data.reduce((sum, cur) => sum + cur.totalSettlementAmount, 0);
    this.source.fcr = Number(this.source.totalSettlementAmount / 1.13 / this.source.totalDeclarationAmount).toFixed(4);
  }
}
